document.addEventListener('DOMContentLoaded', function () {
  const modalOpener = document.querySelector('.product__modal-opener');
  const printRadios = document.querySelectorAll('input[name="Print"]');
  const visiblePrintValues = ['None', 'Classic'];
  const messages = [
    'Trusted by 10,000 Yogis',
    "UK's Best Sustainable Yoga Mat",
    'Trusted by Yoga Teachers',
    'Premium Portuguese Cork'
  ];
  let messageIndex = Math.floor(Math.random() * messages.length);
  let rotationId = null;
  let badgeLabel = null;

  if (!modalOpener || !printRadios.length) {
    return;
  }

  badgeLabel = modalOpener.querySelector('.trusted-badge-label');
  if (!badgeLabel) {
    badgeLabel = document.createElement('span');
    badgeLabel.className = 'trusted-badge-label';
    modalOpener.appendChild(badgeLabel);
  }

  function setMessage() {
    badgeLabel.textContent = messages[messageIndex];
    badgeLabel.classList.add('is-visible');
  }

  function startRotation() {
    if (rotationId) {
      return;
    }

    setMessage();
    rotationId = window.setInterval(function () {
      messageIndex = (messageIndex + 1) % messages.length;
      setMessage();
    }, 10000);
  }

  function stopRotation() {
    if (rotationId) {
      window.clearInterval(rotationId);
      rotationId = null;
    }
  }

  function updateTrustBadge() {
    const selectedPrint = document.querySelector('input[name="Print"]:checked');
    if (selectedPrint && visiblePrintValues.includes(selectedPrint.value)) {
      modalOpener.classList.add('show-trusted-badge');
      startRotation();
    } else {
      modalOpener.classList.remove('show-trusted-badge');
      stopRotation();
    }
  }

  printRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      window.setTimeout(updateTrustBadge, 10);
    });
  });

  updateTrustBadge();
});
